<template>
  <div class="layout-main" v-if="activeMenuCode">
    <div class="header">
      <div class="logo-name">
        <img src="../../assets/logo1.png" alt="">
        <div class="logo-name-split"></div>
        <span class="sys-name">物联网统管云平台</span>
      </div>
      <!-- <div class="search-box">
        <el-input size="mini" class="search-input" v-model="searchKey" placeholder="传感器 / 应用 / 位置......"></el-input>
      </div> -->
      <div class="header-flex_box"></div>
      <!-- <div class="warning-box">
        <el-popover placement="bottom" width="365px" trigger="click">
          <el-tabs type="border-card">
            <el-tab-pane>
              <span slot="label"><i class="el-icon-bell"></i>系统消息</span>
              <div class="scroll-container">
                <div class="message-item" v-for="(item, index) in messageRows" :key="'item' + index">
                  <a>
                    <div class="message-header">
                      <div class="message-title text-ellipsis">
                        <b>{{ item.title }}</b>
                      </div>
                      <div class="message-time">{{ item.createTime }}</div>
                    </div>
                    <p class="text-ellipsis">{{ item.content }}</p>
                  </a>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane>
              <span slot="label"><i class="el-icon-warning"></i>系统告警</span>
              系统告警2
            </el-tab-pane>
            <el-tab-pane>
              <span slot="label"><i class="el-icon-date"></i>系统待办</span>
              系统待办3
            </el-tab-pane>
          </el-tabs>

          <el-badge :value="warningCount" class="warning-badge" slot="reference">
            <img src="../../assets/sys-message.svg" alt="">
          </el-badge>
        </el-popover>
      </div> -->
      <el-dropdown @command="onDropDownClick">
        <div class="user-box">
          <img src="../../assets/avatar-default.png" alt="">
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="user">
            <i class="el-icon-user"></i> 个人中心
          </el-dropdown-item>
          <el-dropdown-item command="logout">
            <i class="el-icon-switch-button"></i> 退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!--      <div class="exit-box" @click="logout">-->
      <!--        <img src="../../assets/logout.svg" alt="">-->
      <!--        <span>安全退出</span>-->
      <!--      </div>-->
    </div>
    <div class="body">
      <div class="menus">
        <el-menu :default-active="activeMenuCode" class="sys-menu" @select="onMenuSelect">
          <el-menu-item class="sys-menu-item" :index="item.code" v-for="item in menus" :key="item.code">
            <template v-if="item.code === 'notice'">
              <img :src="require('@/assets/menu-ico'
                + (item.code === activeMenuCode ? '/selected' : '')
                + '/'
                + item.icon.replace('icon-ico-', '').replace('icon-icon-', '')
                  .replace('icon-ico_', '')
                + '.svg')" />
              <span slot="title" class="badge-menu">
                <el-badge :value="($store.state.user.noticeMeCount > 99 ? '99+' : $store.state.user.noticeMeCount)"
                  v-if="$store.state.user.noticeMeCount > 0">
                  <span>{{ item.text }}</span>
                </el-badge>
                <span v-else>{{ item.text }}</span>
              </span>
            </template>
            <template v-else>
              <img :src="require('@/assets/menu-ico'
                + (item.code === activeMenuCode ? '/selected' : '')
                + '/'
                + item.icon.replace('icon-ico-', '').replace('icon-icon-', '')
                  .replace('icon-ico_', '')
                + '.svg')" />
              <!--              <i class="iconfont menu-icon" :class="[item.icon]"-->
              <!--                 :style="{color: (item.code === activeMenuCode ? '#1890FF' : '#909399')}"></i>-->
              <span slot="title">{{ item.text }}</span>
            </template>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="body-right" :style="{
        backgroundColor: bgColor ? bgColor : (subMenuType === 'button' ? 'transparent' : 'white')
      }">
        <div class="button-submenu" v-if="subMenuType === 'button'">
          <template v-for="menu in subMenus">
            <el-button size="mini" :type="menu.code === activeSubCode ? null : 'text'" :style="{
              color: menu.code === activeSubCode ? 'white' : '#37383A'
            }" :class="menu.code === activeSubCode ? 'button-active-menu' : ''" :key="menu.code"
              v-if="menu.text !== '监控统计'" class="sys-button-menu" @click="subMenuClick(menu.code)">
              {{ menu.text }}
            </el-button>
          </template>

          <div class="flex-space"></div>
          <img src="../../assets/dashboard/home-refresh.svg" alt="">
        </div>
        <div class="sub-menus" v-if="!hideHeader && subMenuType === 'tabs'">
          <el-tabs v-model="activeSubCode" @tab-click="tabClick" v-if="!hiddenSubmenu">
            <template v-for="item in subMenus">
              <el-tab-pane class="tab-sub-menu" :key="item.code"
                v-if="item.code === 'notice_me' && $store.state.user.noticeMeCount > 0" :name="item.code">
                <el-badge slot="label" class="badge-sub-menu"
                  :value="($store.state.user.noticeMeCount > 99 ? '99+' : $store.state.user.noticeMeCount)">
                  <span>{{ item.text }}</span>
                </el-badge>
              </el-tab-pane>
              <el-tab-pane v-else class="tab-sub-menu" :label="item.text" :name="item.code"></el-tab-pane>
            </template>

          </el-tabs>
          <div class="back-button-wrapper" v-else>
            <el-button @click="back" icon="el-icon-back" size="mini">{{ backText }}</el-button>
          </div>
        </div>
        <div class="content" :class="subMenuType === 'button' ? 'nobtpd' : ''" :style="{
          borderTop: (hideHeader || subMenuType === 'button' ? 'none !important' : '1px solid #dfe4ed88 !important'),
        }" v-if="!defineContent">
          <div class="content-main scrollable-box" :class="subMenuType === 'button' ? 'no-scbar' : ''"
            :style="subMenuType === 'button' ? 'padding-top:0' : ''">
            <router-view />
          </div>
        </div>
        <div v-else style="height: 100%;">
          <router-view />
        </div>
      </div>
    </div>

    <el-dialog title="个人中心" :visible.sync="userDialogVisible" width="70%" :fullscreen="true" :before-close="handleClose"
      :append-to-body="true">
      <UserInfo @close-user="closeUser" />
    </el-dialog>
  </div>
  <router-view v-else />
</template>

<script>
import { getMyList } from "@/api/system/message"
import UserInfo from "@/components/common/userInfo.vue"
export default {
  name: 'layout',
  components: { UserInfo },
  data() {
    return {
      userDialogVisible: false,
      noticeMeCountInterval: null, // 轮询数量计时器
      // 是否隐藏页面头部
      hideHeader: false,
      // 不显示子菜单的情况下，显示返回按钮的文字
      backText: '返回',
      //是否显示tab菜单 如果是子菜单的话就不显示顶部的子菜单
      hiddenSubmenu: false,
      // 子菜单类型
      subMenuType: 'tabs',
      // 子页面中是否不使用统一内容框架
      defineContent: false,
      // 右侧内容区背景色
      bgColor: '',
      activeSubCode: '',
      // 当前激活的菜单
      activeMenuCode: 'dashboard',
      // 菜单
      menus: [],
      // 搜索关键词
      searchKey: '',
      // 告警数量
      warningCount: "99+",
      user: {
        nickname: this.$store.state.user.nickname
      },
      messageRows: [
        {
          title: "升级通知升级通知升级通知升级通知升级通知升级通知升级通知升级通知升级通知升级通知升级通知",
          content: "系统于今天晚上8：00进行升级.....系统于今天晚上8：00进行升级.....系统于今天晚上8：00进行升级.....系统于今天晚上8：00进行升级.....系统于今天晚上8：00进行升级.....",
          createTime: "2025-02-11"
        },
        {
          title: "升级通知升级通知升级通知升级通知升级通知升级通知升级通知升级通知升级通知升级通知升级通知",
          content: "系统于今天晚上8：00进行升级.....系统于今天晚上8：00进行升级.....系统于今天晚上8：00进行升级.....系统于今天晚上8：00进行升级.....系统于今天晚上8：00进行升级.....",
          createTime: "2025-02-11"
        }
      ]
    }
  },
  computed: {
    subMenus() {
      if (this.menus.length > 0) {
        const findIndex = this.menus.findIndex(s => s.code === this.activeMenuCode)
        if (findIndex > -1) {
          const subs = this.menus[findIndex].subMenus
          return subs || []
        }
      }
      return []

    }
  },
  watch: {
    // 框架刷新后Vuex 状态会丢失，在layout中监听Vx的状态，一旦丢失就需要重新加载
    '$store.state.user.permissions': {
      async handler(val) {
        if (!localStorage.getItem("token")) {
          return
        }
        if (val && val.length === 0) {
          await this.$store.dispatch('GetInfo')
          await this.$store.dispatch('GetOrgList')
        }
      },
      deep: true,
      immediate: true
    },
    // 框架刷新后Vuex 状态会丢失，在layout中监听Vx的状态，一旦丢失就需要重新加载
    '$store.state.user.routers': {
      // eslint-disable-next-line
      async handler(val) {
        if (!localStorage.getItem("token")) {
          return
        }
        if (val && val.length === 0) {
          await this.$store.dispatch('GetRouterMenus')
        } else {
          const routeDatas = val || []
          this.menus = JSON.parse(JSON.stringify(routeDatas)).filter(s => s.isShowInIot).map(s => {
            const text = s.meta.title
            const icon = s.meta.icon
            const code = s.name.toLowerCase()
            let subMenus = null
            if (s.children && s.children.length > 0) {
              subMenus = s.children.filter(c => !c.hidden).map(c => {
                const text = c.meta.title
                const code = c.name.toLowerCase().replaceAll("/", "_")
                return { text, code }
              })
            }
            return { text, icon, code, subMenus }
          })
        }
      },
      deep: true,
      immediate: true
    },
    $route: {
      // eslint-disable-next-line
      handler(to, from) {
        const path = to.path
        if (path === '/login') {
          this.destroyNoticeAsk()
        } else if (from && from.path === '/login') {
          this.$store.dispatch("GetNoticeMeCount")
          this.askNoticeUnReadCount()
        }
        const routerItem = this.$router.options.routes.find(s => s.path === path)
        if (routerItem && routerItem.bg) {
          this.bgColor = routerItem.bg
        } else {
          this.bgColor = ''
        }
        // 子菜单显示类型
        if (routerItem && routerItem.subMenuType && routerItem.subMenuType === 'button') {
          this.subMenuType = 'button'
          this.hiddenSubmenu = true
        } else {
          this.subMenuType = 'tabs'
          if (routerItem && routerItem.hidden) {
            this.hiddenSubmenu = true
            this.backText = routerItem.backText || '返回'
            this.hideHeader = routerItem.hideHeader
          } else {
            this.hiddenSubmenu = false
            this.hideHeader = false
          }
        }
        // 控制内容框架显示
        if (routerItem && routerItem.defineContent) {
          this.defineContent = true
        } else {
          this.defineContent = false
        }

        // 控制子菜单按钮显示
        if (path === '/404' || path === '/login') {
          this.activeMenuCode = ""
          this.activeSubCode = ""
          return
        }
        if (path === "/") {
          this.activeSubCode = 'dashboard_view'
        } else {
          // 按照约定的格式取路由的子菜单code
          this.activeSubCode = path.substring(1).replaceAll('/', '_')
        }
        // 定位左侧菜单选中项
        const menuCode = this.activeSubCode.split('_')[0]
        if (menuCode) {
          this.activeMenuCode = menuCode
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {

    const href = location.href
    const origin = location.origin
    const path = href.replaceAll(origin, '')
    // 先判断 404 403 等页面。。
    if (path === '/404' || path === '/login') {
      this.activeMenuCode = ""
      this.activeSubCode = ""
      return
    }
    // 根路由比较特殊
    if (path === "/") {
      this.activeSubCode = 'dashboard_view'
    } else {
      // 按照约定的格式取路由的子菜单code
      this.activeSubCode = path.substring(1).replaceAll('/', '_')
    }
    // 定位左侧菜单选中项
    const menuCode = this.activeSubCode.split('_')[0]
    if (menuCode) {
      this.activeMenuCode = menuCode
    }
    if (path !== "/login") {
      this.$store.dispatch("GetNoticeMeCount")
      this.askNoticeUnReadCount()
    } else {
      this.destroyNoticeAsk()
    }
    this.getMessageList()
  },
  beforeDestroy() {
    this.destroyNoticeAsk()
  },
  methods: {
    onDropDownClick(e) {
      if (e === 'user') {
        this.userDialogVisible = true
      } else {
        this.logout()
      }
    },
    destroyNoticeAsk() {
      if (this.noticeMeCountInterval) {
        clearInterval(this.noticeMeCountInterval)
        this.noticeMeCountInterval = null
      }
    },
    askNoticeUnReadCount() {
      if (!this.noticeMeCountInterval) {
        this.noticeMeCountInterval = setInterval(() => {
          this.$store.dispatch("GetNoticeMeCount")
        }, 15000)
      }
    },
    back() {
      this.$router.back()
    },
    getMenus() {
      console.log(this.$store.state.user.routers, 'routers')
    },
    subMenuClick(code) {
      const codeToPath = `/${code.replaceAll('_', '/')}`
      if (this.$route.path !== codeToPath) {
        this.$router.push(codeToPath)
      }
    },
    tabClick(e) {
      const codeToPath = `/${e.name.replaceAll('_', '/')}`
      if (this.$route.path !== codeToPath) {
        this.$router.push(codeToPath)
      }
    },
    onMenuSelect(e) {
      if (this.activeMenuCode !== e) {
        this.activeMenuCode = e
        const subMenus = this.subMenus
        if (subMenus.length > 0) {
          const firstSubmenu = subMenus[0]
          const codeToPath = `/${firstSubmenu.code.replaceAll('_', '/')}`
          this.activeSubCode = firstSubmenu.code
          this.$router.push(codeToPath)
        } else {
          if (this.$route.path !== '/404') {
            this.activeMenuCode = ""
            this.activeSubCode = ""
            this.$router.push("/404")
          }
        }
      }
    },
    logout() {
      localStorage.clear()
      this.$router.replace('/login')
    },
    getMessageList(query) { // 获取列表数据
      getMyList(query).then(response => {
        this.messageRows = response.rows
      })
    },
    closeUser() {
      this.userDialogVisible = false
    },
    handleClose(done) {
      done()
    }
  }
}
</script>
<style lang="scss" scoped>
:deep .search-input {
  width: 500px;

  input:focus {
    border-color: white !important;
  }

}

.layout-main {
  position: relative;
  height: 100vh;
  background: linear-gradient(109.02deg, #E5EFFB 8.81%, #DBDCF8 36.35%, #E5EEFB 91.84%);
  overflow-y: hidden;
  z-index: 2;
  display: flex;
  flex-direction: column;


  .header {
    display: flex;
    align-items: center;
    position: relative;
    z-index: 2;
    padding: 16px;

    .logo-name {
      display: flex;
      align-items: center;

      img {
        margin-right: 16px;
        width: 66px;
        padding: 0 12px;
        height: 40px;
        box-sizing: border-box;
      }

      .logo-name-split {
        width: 1px;
        height: 16px;
        background-color: #00000022;
        display: inline-block;
        position: relative;
        top: 0.5px;
      }

      .sys-name {

        font-size: 16px;
        color: #000000;
        font-weight: 400;
        margin-left: 14px;
        font-family: 'FZZhengHeiS-M-GB';
        font-style: normal;
        line-height: 19px;
        flex: none;
        order: 2;
        flex-grow: 0;

      }
    }

    .search-box {
      position: relative;
      display: flex;
      align-items: center;
      margin-left: 24px;
      margin-bottom: 0;

      .search-btn {
        position: absolute;
        right: 0;
        border: none;
        background-color: #FFB142;
        top: 0;
        height: 28px;
      }
    }

    .header-flex_box {
      flex: 1;
      height: 1px;
    }

    .warning-box {
      cursor: pointer;
      display: flex;

      img {
        width: 32px;
      }

      .warning-badge {
        font-size: 12px;
      }

      .warning-text {
        padding: 12px 12px 12px 0;
        color: white;
        font-size: 14px;
      }
    }

    .user-box {
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 8px;
      margin-left: 20px;

      img {
        width: 40px;
        height: 40px;
        border-radius: 200px;
      }

      .user-nickname {
        color: white;
        font-size: 14px;
      }
    }

    .exit-box {
      cursor: pointer;
      display: flex;
      align-items: center;
      margin-left: 64px;
      gap: 4px;

      span {
        font-size: 14px;
        color: white;
      }
    }
  }

  .body {
    width: 100%;
    display: flex;
    flex: 1;
    gap: 16px;
    height: calc(100% - 96px);
    position: relative;
    z-index: 2;
    padding: 0 16px 32px;

    .menus {
      height: 100%;
      padding: 0;
      box-sizing: border-box;
      background-color: white;
      min-width: 66px;
      width: 66px;
      border-radius: 8px;
      background-color: transparent !important;

      .sys-menu::-webkit-scrollbar {
        display: none;
      }

      .sys-menu {
        height: 100%;
        overflow-y: auto;

        li {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          gap: 12px;
          position: relative;
        }

        li.is-active {
          background: linear-gradient(90deg, #48A6FF 1.87%, #717FFF 91.25%);
          border-radius: 8px;

          span {
            color: white;
          }
        }

      }
    }

    .body-right {
      flex: 1;
      display: flex;
      flex-direction: column;
      height: 100%;
      background-color: white;
      border-radius: 8px;
      max-width: calc(100vw - 32px - 66px - 16px);

      .sub-menus {
        //padding: 20px;
        padding: 0 20px;
      }


      .content {
        flex: 1;
        overflow-y: auto;
        padding-bottom: 12px;
        box-sizing: border-box;

        .content-main::-webkit-scrollbar {
          //display: none;
        }

        .content-main {
          padding: 20px 20px 8px 20px;
          box-sizing: border-box;
          height: 100%;
          overflow-y: auto;
          position: relative;
        }

        .no-scbar {
          padding-right: 0;
          padding-left: 0;
          padding-bottom: 0;
        }

        .no-scbar::-webkit-scrollbar {
          //display: none;
        }
      }

      .nobtpd {
        padding-bottom: 0;
      }
    }
  }
}

.sub-menus {
  background-color: #fff;
  border-radius: 8px 8px 0 0;

  :deep .el-tabs__item {
    line-height: 56px !important;
    font-size: 14px;
    font-weight: 600;
    padding: 0 8px;
  }

  :deep .el-tabs__nav {
    height: 40px;
  }

  :deep .el-tabs__active-bar {
    bottom: 0px;
  }

  :deep .el-tabs__nav-wrap::after {
    display: none;
    height: 1px;
    background-color: #dfe4ed55;
  }
}


.back-button-wrapper {
  height: 54px;
  display: flex;
  align-items: center;
}

.menu-icon {
  font-size: 20px;
}

:deep .el-menu {
  border-right: none !important;
  background-color: transparent;
}

:deep .el-menu-item {
  flex-direction: column;
  gap: 4px !important;
  line-height: normal;
  margin-bottom: 8px;
  height: 66px;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 8px;

  span {
    font-size: 12px;
    letter-spacing: 1px;
    color: #707F8D;
  }
}

.scroll-container {
  max-height: 400px;
  /* 设置最大高度 */
  overflow-y: auto;
  /* 启用垂直滚动 */
}

.message-item {
  width: 365px;
}

.message-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.message-title {
  width: 250px;
}


.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.badge-menu {
  :deep .el-badge__content.is-fixed {
    top: 50%;
    right: -20px;
  }
}

.badge-sub-menu {
  :deep .el-badge__content.is-fixed {
    top: 20px;
    right: 8px;
  }
}

.sys-menu-item {
  width: 66px;
  padding: 0 !important;
}

.warning-box {
  :deep .el-badge__content {
    background-color: #CC4A31;
  }

  :deep .el-badge__content.is-fixed {
    top: 6px;
    right: 16px;
  }
}

.button-submenu {
  margin-left: 8px;
  display: flex;
  align-items: center;
  padding-bottom: 12px;

  .flex-space {
    flex: 1;
  }

  img {
    margin-right: 16px;
    cursor: pointer;
  }

  :deep .el-button--text {
    width: 66px;
  }
}

.sys-button-menu {
  outline: none !important;
  border: none !important;
  font-size: 14px;
}

.sys-button-menu.button-active-menu {
  background: linear-gradient(90deg, #48A6FF 1.87%, #717FFF 91.25%);
  border-radius: 6px;
}

.sub-menus {
  :deep .el-tabs__header {
    margin-bottom: 0;
  }

  :deep .el-tabs__nav {
    height: 48px;
  }

  :deep .el-tabs__item {
    font-weight: 500;
  }
}
</style>
